export const LAB_LOOKS = [
  { key: "natural", name: "Natural", lips: "#C98A7A", blush: "#EFC0B4", eyes: "#B89078", liner: false, gloss: true, intensity: 0.55 },
  { key: "bridal", name: "Bridal", lips: "#B3122E", blush: "#E8788A", eyes: "#8A4B2E", liner: true, gloss: true, intensity: 0.9 },
  { key: "editorial", name: "Editorial", lips: "#7A1F3D", blush: "#D98A9C", eyes: "#4A2530", liner: true, gloss: false, intensity: 1 },
  { key: "glam", name: "Glam", lips: "#E62E6B", blush: "#F28FB0", eyes: "#6E2C3C", liner: true, gloss: true, intensity: 1 },
];
